import { IUser } from '~/utils/types'

export const checkIsManager = (user: IUser): boolean => {
  if (!user.profile) return false
  if (user.profile === 'manager') return true
  return false
}
